import {Observable} from "rxjs/Rx";
import {INotificationsCommonWebServiceClient} from "@resources/resources";
import {Injectable} from "@angular/core";
import {Resolve} from "@angular/router";

@Injectable()
export class NotificationNumberResolver implements Resolve<any> {

  constructor(private notificationsWebService: INotificationsCommonWebServiceClient) {
  }

  resolve() {
    return this.notificationsWebService.countMessageNotifications().catch(response => {
      return Observable.of(0);
    });
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-factures/digicerba-factures-web/src/angular/cerba/src/app/pages/cerba/notification.resolver.ts